import React from 'react';
import { EyeOff } from 'react-feather';

const TrackingUnavailableView = ({ remainingCount }) => {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      width: '100vw',
      backgroundColor: '#f8f9fa',
      fontFamily: 'Arial, sans-serif',
      textAlign: 'center',
      padding: '20px',
      boxSizing: 'border-box',
      position: 'relative'
    }}>
      {remainingCount !== null && remainingCount !== undefined && (
        <div style={{
          position: 'absolute',
          top: '20px',
          right: '20px',
          backgroundColor: remainingCount <= 5 ? '#e74c3c' : '#2ecc71',
          color: '#fff',
          padding: '8px 16px',
          borderRadius: '20px',
          fontWeight: 'bold',
          boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
          zIndex: 9999
        }}>
          Views Remaining: {remainingCount}
        </div>
      )}
      <div style={{
        backgroundColor: '#ffebee',
        padding: '24px',
        borderRadius: '50%',
        marginBottom: '16px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center'
      }}>
        <EyeOff size={48} color="#d32f2f" />
      </div>
      <h2 style={{ color: '#212121', marginBottom: '8px', fontSize: '24px' }}>
        Tracking Unavailable
      </h2>
      <p style={{ color: '#666', maxWidth: '400px', fontSize: '16px', margin: '0' }}>
        You cannot track at this current job status. External tracking is only available for specific stages.
      </p>
    </div>
  );
};

export default TrackingUnavailableView;